import { EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent, CheckTableComponent, ButtonDownloadComponent } from '@app/shared';
import { ButtonDownloadCheckComponent } from '@app/shared/component-table/button-download-check-table.component';
import { data } from 'jquery';
import { DateFormatPipe } from '@app/shared/pipes/moment/date-format.pipe';

export class QRDocumentsPageConfigService {
  // Se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion base para tablas
  baseSettings = {};

  constructor() {
    const self = this;
    this.settings = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay aprobaciones o firmas para el documento',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        funcionario: {
          editable: false,
          addable: false,
          title: 'Funcionario',
          filter: {
            inputClass: 'form-control',
          }
        },
        accion: {
          editable: false,
          addable: false,
          title: 'Acción realizada',
          filter: {
            inputClass: 'form-control',
          }
        }
      }
    };
    this.baseSettings = {
      mode: 'external',
      actions: false,
      noDataMessage: 'No hay información disponible',
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
      }
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/qr-documents-page/shared/qr-documents-page.config.service.ts